export default __webpack_public_path__ + "static/media/support-notes-logo-expansion.37c1f53b.svg";